
import React from "react";
import { Tabs } from "@/components/ui/tabs";
import MovieTabContent from "@/components/page/MovieTabContent";
import { MoviesByDirector } from "@/types/movie";
import EmptyStateMessages from "@/components/page/EmptyStateMessages";
import { LIST_NAMES, type MovieListName } from "@/hooks/search/types/listConstants";

interface MainContentProps {
  currentTab: MovieListName;
  transitionDirection: "left" | "right" | null;
  viewMode: "grid" | "list";
  favoriteMovies: MoviesByDirector;
  unseenDirectorMovies: MoviesByDirector;
  planToWatchMovies: MoviesByDirector;
  isAuthenticated: boolean;
  onTabChange: (value: MovieListName) => void;
  onOpenMovieDetails: (tmdbId: number) => void;
  onSearchFocus: () => void;
}

/**
 * Main content component that manages tabs and their content
 */
const MainContent: React.FC<MainContentProps> = ({ 
  currentTab,
  transitionDirection,
  viewMode,
  favoriteMovies,
  unseenDirectorMovies,
  planToWatchMovies,
  isAuthenticated,
  onTabChange,
  onOpenMovieDetails,
  onSearchFocus
}) => {
  return (
    <main className="container mx-auto pt-8 md:pt-12 lg:pt-16 pb-12 md:pb-16 lg:pb-20 fade-in relative z-10">
      <Tabs 
        value={currentTab}
        onValueChange={onTabChange}
        className="w-full"
      >
        {/* Added overflow-hidden to prevent scrollbars during animation */}
        <div className="relative overflow-hidden">
          <MovieTabContent 
            value={LIST_NAMES.FAVORITES}
            moviesByDirector={favoriteMovies}
            emptyMessage={
              <EmptyStateMessages 
                tabType={LIST_NAMES.FAVORITES} 
                isAuthenticated={isAuthenticated} 
                onSearchFocus={onSearchFocus} 
              />
            }
            currentTab={currentTab}
            direction={transitionDirection}
            viewMode={viewMode}
            isAuthenticated={isAuthenticated}
            onOpenMovieDetails={onOpenMovieDetails}
          />

          <MovieTabContent 
            value={LIST_NAMES.UNSEEN_GEMS}
            moviesByDirector={unseenDirectorMovies}
            emptyMessage={
              <EmptyStateMessages 
                tabType={LIST_NAMES.UNSEEN_GEMS} 
                isAuthenticated={isAuthenticated} 
                onSearchFocus={onSearchFocus} 
              />
            }
            currentTab={currentTab}
            direction={transitionDirection}
            viewMode={viewMode}
            isAuthenticated={isAuthenticated}
            onOpenMovieDetails={onOpenMovieDetails}
          />

          <MovieTabContent 
            value={LIST_NAMES.WATCHLIST}
            moviesByDirector={planToWatchMovies}
            emptyMessage={
              <EmptyStateMessages 
                tabType={LIST_NAMES.WATCHLIST} 
                isAuthenticated={isAuthenticated} 
                onSearchFocus={onSearchFocus} 
              />
            }
            currentTab={currentTab}
            direction={transitionDirection}
            viewMode={viewMode}
            isAuthenticated={isAuthenticated}
            onOpenMovieDetails={onOpenMovieDetails}
          />
        </div>
      </Tabs>
    </main>
  );
};

export default MainContent;
